import { render, staticRenderFns } from "./g-left-right.vue?vue&type=template&id=62c1a19d&"
import script from "./g-left-right.vue?vue&type=script&lang=js&"
export * from "./g-left-right.vue?vue&type=script&lang=js&"
import style0 from "./g-left-right.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports